<script>
	import InputWrapper from '../InputWrapper.svelte';

	let {
		name,
		group = $bindable(),
		element = $bindable(),
		options = null,
		class: className = '',
		disabled = false,
		required = false,
		error = null,
		valueField = 'value',
		labelField = 'label',
		label = null,
		...props
	} = $props();
</script>

<InputWrapper {label} {error} class={className}>
	<fieldset
		class={[
			'col-span-full flex h-auto min-h-0 w-full content-between items-start justify-items-start gap-x-4 border-none',
			{ 'bg-indow-grey-light cursor-not-allowed': disabled },
			{ 'border-indow-red': error },
		]}
		bind:this={element}
		{...props}
	>
		{#each options as option (option[valueField])}
			<label class="mb-3 flex cursor-pointer items-center gap-2">
				<input
					type="radio"
					{name}
					value={option[valueField]}
					{disabled}
					{required}
					bind:group
					{...props}
					class="border-indow-grey-dark text-indow-blue checked:border-indow-blue h-8 w-8"
				/>
				<span class="text-indow-grey-dark">{option[labelField]}</span>
			</label>
		{/each}
	</fieldset>
</InputWrapper>
